// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';
export let DirectNonFixedInstumentStrikesResponseMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_INSTRUMENT_STRIKES_RESPONSE)
    this.instrID;
    this.instrName;
    this.strikePricesList;
    this.optionContractGroup; //по сути э
    this.PointSize;

    //когда имя фьючерса (и каждого страйка) может прис
    this.FutureAliasName = null;
    this.useAliasName = false;
}